import cx from 'classnames';
import CtaButton from '@/vdp/CtaButton';
import Tags from '@/vdp/Tags';
import Price from '~/components/vdp/PriceExperiment';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import useCtaButtonState from '~/hooks/vdp/selectors/useCtaButtonState';
import StarRating from './StarRating';
import TermsShippingAndGetItBy from './TermsShippingAndGetItBy';

type OwnProps = {
  isVDPLite?: boolean;
};

export default function HeroVehicleInfo({ isVDPLite = false }: OwnProps) {
  const {
    make = '',
    mileage = 0,
    model = '',
    trim = '',
    year = ''
  } = useGetVehicleDetails();
  const { isDisabled, notifyMe } = useCtaButtonState();

  return (
    <div className="grid h-fit gap-y-16 p-16 m:gap-y-2xl m:p-2xl l:gap-y-3xl l:p-0">
      <div className="grid gap-y-lg m:gap-y-16">
        <Tags />

        <div className="text-blue-6">
          <p className="tl-header-m m:tl-header-xl">
            {year} {make} {model}
          </p>
          <p className="grid w-fit grid-flow-col gap-x-4 tl-body-s m:gap-x-md m:tl-body-m">
            <span>{trim}</span>
            <span>•</span>
            <span>{mileage.toLocaleString()} miles</span>
          </p>
        </div>

        <StarRating />
      </div>

      <div className="grid gap-y-md">
        <Price />
        <TermsShippingAndGetItBy />
      </div>

      {isVDPLite && notifyMe ? null : (
        <div className="hidden l:grid l:gap-y-md">
          <CtaButton
            className={cx('w-full', { disabled: isDisabled })}
            data-analytics-id="Hero - CTA Button"
            data-qa="get-started-button"
          />
        </div>
      )}
    </div>
  );
}
